import React from 'react'
import { IconProps } from './types'
import { colors } from '../consts'

export const Ticket: React.FC<React.PropsWithChildren<IconProps>> = ({
  width,
  height,
  iconColor,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.7278 2L15.9389 3.21115C15.4352 3.7149 15.4352 4.52947 15.9389 5.02787C16.4373 5.53162 17.2519 5.53162 17.7556 5.02787L18.9668 6.24437C18.463 6.74276 18.463 7.55734 18.9668 8.06109C19.4705 8.55949 20.2851 8.55949 20.7835 8.06109L22 9.27224L19.5509 11.716L18.4577 10.6227L17.7342 11.3516L18.8274 12.4448L9.27224 22L8.06109 20.7835C8.55949 20.2851 8.55949 19.4705 8.06109 18.9668C7.55734 18.463 6.74276 18.463 6.24437 18.9668L5.02787 17.7556C5.53162 17.2519 5.53162 16.4373 5.02787 15.9389C4.52947 15.4352 3.7149 15.4352 3.21115 15.9389L2 14.7278L11.5552 5.17256L12.6484 6.26581L13.3719 5.53698L12.2787 4.44373L14.7278 2V2ZM14.3526 6.51768L15.4405 7.60557L14.717 8.3344L13.6238 7.24116L14.3526 6.51768ZM16.3891 8.54877L17.477 9.64201L16.7481 10.3708L15.6602 9.2776L16.3891 8.54877Z"
      fill={iconColor ?? colors.yellow}
    />
  </svg>
)
